module.exports = __webpack_public_path__ + "static/media/spca_logo.1064c442.svg";